module.exports = __webpack_public_path__ + "media/images/map_icons/Fishing-2ad6bd96e4737c8ae312676f6d6bef83.svg";